<form [formGroup]="naturalForm" (ngSubmit)="validateForm()">
  <div class="myForm">
    @if (currentStep === 1) {
      <div class="form-section-header mb-2">
        <h3 class="form-section-header__title">Información general</h3>
        <p class="form-section-header__subtitle mt-3">
          <img src="assets/img/Inicio_sesion/svg/Ico_Datos_Generales.svg" 
          alt="" class="form-section-header__icon" aria-hidden="true" />
          Datos generales
        </p>
      </div>
      <div class="form-fields-flow mt-3">
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ err: validateField('primerNombre') }">
            <label for="primerNombre" class="form-label">Primer nombre</label>
            <input
              type="text"
              class="form-control toCapitalizeWords"
              maxlength="20"
              formControlName="primerNombre"
              id="primerNombre"
              placeholder="Digita primer nombre"
              (keyup)="validarTexto($event)"
              appOnlyLetters
              appNextFieldId="primerApellido"
              [ngClass]="{ 'is-invalid': validateField('primerNombre') }"
              required
            />
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ err: validateField('primerApellido') }">
            <label for="primerApellido" class="form-label">Primer apellido</label>
            <input
              class="form-control toCapitalizeWords"
              maxlength="20"
              formControlName="primerApellido"
              id="primerApellido"
              placeholder="Digita primer apellido"
              appOnlyLetters
              (keyup)="validarTexto($event)"
              appNextFieldId="idTipoDocIdentidad"
              [ngClass]="{ 'is-invalid': validateField('primerApellido') }"
              required
            />
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idTipoDocIdentidad') }">
            <label for="idTipoDocIdentidad" class="form-label">Tipo de documento</label>
            <select
              class="form-control"
              formControlName="idTipoDocIdentidad"
              (change)="validarSelect()"
              [ngClass]="{ 'is-invalid': validateField('idTipoDocIdentidad'), 'placeholder-selected': !naturalForm.get('idTipoDocIdentidad').value }"
              id="idTipoDocIdentidad"
              [appNextFieldId]="naturalForm.get('idTipoDocIdentidad').value !== '2' ? 'idPaisOrigen' : 'numeroDocumento'"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona tipo documento</option>
              @for (documento of documentos; track documento) {
                <option [value]="documento.idTipoDocIdentidad">
                  {{ documento.nombre }}
                </option>
              }
            </select>
            <div class="invalid-feedback">
              Campo obligatorio
            </div>
          </div>
        </div>
        @if (isPasaporte) {
          <div class="form-field-item">
            <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idPaisOrigen') }" required>
              <label for="idPaisOrigen" class="form-label">¿Cuál es tu nacionalidad?</label>
              <select
                class="form-control selectpicker"
                data-live-search="true"
                data-width="100%"
                data-size="5"
                #idPaisOrigen
                id="idPaisOrigen"
                title="Selecciona país"
                formControlName="idPaisOrigen"
                appNextFieldId="numeroDocumento"
                (change)="selectpikerChange('idPaisOrigen')"
                [ngClass]="{ 'is-invalid': validateField('idPaisOrigen') }"
                required
              >
                <option [value]="''" class="option-placeholder">Selecciona país</option>
                @for (pais of paises; track pais) {
                  <option [value]="pais.idPais">
                    {{ pais.nombrePais }}
                  </option>
                }
              </select>
              <div class="invalid-feedback">Campo es obligatorio</div>
            </div>
          </div>
        }
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('numeroDocumento') }">
            <label for="numeroDocumento" class="form-label">Número de documento</label>
            <input
              type="text"
              class="form-control"
              id="numeroDocumento"
              formControlName="numeroDocumento"
              placeholder="Digita documento"
              maxlength="15"
              appNumeroDocumentoPorTipo
              [idTipoDocControlName]="'idTipoDocIdentidad'"
              [tipos]="documentos"
              appNextFieldId="confirmNumeroDocumento"
              [ngClass]="{ 'is-invalid': validateField('numeroDocumento') }"
              aria-describedby="numeroDocumento-error"
              required
            />
            <div class="invalid-feedback d-block" id="numeroDocumento-error" *ngIf="validateField('numeroDocumento')">
              {{ naturalForm.get('numeroDocumento').hasError('required') ? 'Campo obligatorio' : getDocumentPatternMessage('numeroDocumento') }}
            </div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('confirmNumeroDocumento') || naturalForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch') }">
            <label for="confirmNumeroDocumento" class="form-label">Confirma tu número de documento</label>
            <input
              type="text"
              class="form-control"
              id="confirmNumeroDocumento"
              formControlName="confirmNumeroDocumento"
              placeholder="Digita nuevamente documento"
              maxlength="15"
              appNumeroDocumentoPorTipo
              [idTipoDocControlName]="'idTipoDocIdentidad'"
              [tipos]="documentos"
              [allowPaste]="false"
              oncopy="return false"
              appNextFieldId="idGenero"
              [ngClass]="{ 'is-invalid': validateField('confirmNumeroDocumento') || naturalForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch') }"
              aria-describedby="confirmNumeroDocumento-error mensaje-error-confirmarNumeroDocumento"
              required
            />
            <div class="invalid-feedback d-block" id="confirmNumeroDocumento-error" *ngIf="naturalForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch')">
              Los números de documento no coinciden
            </div>
            <div class="invalid-feedback d-block" id="mensaje-error-confirmarNumeroDocumento" *ngIf="validateField('confirmNumeroDocumento') && !naturalForm.controls.confirmNumeroDocumento?.hasError('confirmNumeroDocumentoMatch')">
              {{ naturalForm.get('confirmNumeroDocumento').hasError('required') ? 'Campo obligatorio' : getDocumentPatternMessage('confirmNumeroDocumento') }}
            </div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idGenero'), 'placeholder-selected': !naturalForm.get('idGenero').value}">
            <label for="idGenero" class="form-label">Género</label>
            <select
              class="form-control"
              id="idGenero"
              formControlName="idGenero"
              appNextFieldId="numeroCelular"
              [ngClass]="{ 'is-invalid': validateField('idGenero'), 'placeholder-selected': !naturalForm.get('idGenero').value }"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona género</option>
              @for (genero of generos; track genero) {
                <option [value]="genero.idGenero">
                  {{ genero.nombre }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('numeroCelular') }">
            <label for="numeroCelular" class="form-label">Número de celular</label>
            <input
              class="form-control"
              minlength="10"
              maxlength="10"
              formControlName="numeroCelular"
              placeholder="Digita número de celular"
              appOnlyNumbers
              appNextFieldId="correoElectronico"
              [ngClass]="{ 'is-invalid': validateField('numeroCelular') }"
              id="numeroCelular"
              required
            />
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ err: validateField('correoElectronico') }">
            <label for="correoElectronico" class="form-label">Correo electrónico</label>
            <input
              type="email"
              class="form-control"
              maxlength="50"
              formControlName="correoElectronico"
              placeholder="Digita correo electrónico"
              (input)="naturalForm.get('correoElectronico').setValue($event.target.value.toLowerCase())"
              appNextFieldId="tieneRUT"
              [ngClass]="{ 'is-invalid': validateField('correoElectronico') }"
              id="correoElectronico"
              required
            />
            <div class="invalid-feedback d-block" *ngIf="validateField('correoElectronico')">
              {{ getCorreoElectronicoErrorMessage() }}
            </div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3" [ngClass]="{ 'is-invalid': validateField('tieneRUT') }">
            <label for="tieneRUT" class="form-label">¿Tiene RUT?</label>
            <div>
              <div class="form-check form-check-inline ms-4" [ngClass]="{ 'is-invalid': validateField('tieneRUT') }">
                <input
                  [value]="'SI'"
                  type="radio"
                  class="form-check-input"
                  formControlName="tieneRUT"
                  name="tieneRUT"
                  id="tieneRUTSi"
                  [ngClass]="{ 'is-invalid': validateField('tieneRUT') }"
                />
                <label for="tieneRUTSi" class="form-check-label">Sí</label>
              </div>
              <div class="form-check form-check-inline ms-4" [ngClass]="{ 'is-invalid': validateField('tieneRUT') }">
                <input
                  [value]="'NO'"
                  type="radio"
                  class="form-check-input"
                  formControlName="tieneRUT"
                  name="tieneRUT"
                  id="tieneRUTNo"
                  [ngClass]="{ 'is-invalid': validateField('tieneRUT') }"
                />
                <label for="tieneRUTNo" class="form-check-label">No</label>
              </div>
              <div class="invalid-feedback">Campo obligatorio</div>
            </div>
          </div>
        </div>
        @if (naturalForm.get('tieneRUT')?.value) {
          <div class="form-field-item">
            <div class="mb-3" [ngClass]="{ 'is-invalid': validateField('idFuenteNeocredito') }" required>
            <label for="idFuenteNeocredito" class="form-label">¿Cómo te enteraste de neocrédito?</label>
            <select
              #idFuenteNeocredito
              id="idFuenteNeocredito"
              class="form-control selectpicker"
              [ngClass]="{ 'is-invalid': validateField('idFuenteNeocredito') }"
              data-live-search="true"
              formControlName="idFuenteNeocredito"
              required
              data-size="6"
              [appNextFieldId]="isReferido ? 'nombreReferido' : 'idDepartamento'"
              (change)="valueSelected($event.target.value)"
              title="Selecciona una opción"
            >
              <option [value]="''" class="option-placeholder">Selecciona una opción</option>
              @for (elemento of fuentesInformacion; track elemento) {
                <option [value]="elemento.idFuenteNeocredito">
                  {{ elemento.fuente }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
          </div>
        }
        @if (isReferido) {
          <div class="form-field-item">
            <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('nombreReferido') }">
              <label for="nombreReferido" class="form-label">¿Quién te refirió?</label>
              <input
                type="text"
                class="form-control"
                maxlength="60"
                formControlName="nombreReferido"
                id="nombreReferido"
              placeholder="Digita nombre de refirió"
              appNextFieldId="codigoReferido"
              [ngClass]="{ 'is-invalid': validateField('nombreReferido') }"
            />
              @if (naturalForm.get('nombreReferido')?.errors?.['referidoRequired']) {
                <div class="invalid-feedback">Completa al menos uno: ¿Quién te refirió? o Código del referido.</div>
              }
            </div>
          </div>
          <div class="form-field-item">
            <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('nombreReferido') }">
              <label for="codigoReferido" class="form-label">Código del referido</label>
            <input
              type="text"
              class="form-control"
              id="codigoReferido"
              autocomplete="off"
              maxlength="20"
              formControlName="codigoReferido"
              placeholder="Digita código referido"
              [appNextFieldId]="isOtraFuente ? 'otraFuente' : 'idDepartamento'"
              [ngClass]="{ 'is-invalid': validateField('nombreReferido') }"
            />
            </div>
          </div>
        }
        @if (isOtraFuente) {
          <div class="form-field-item">
            <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('otraFuente') }">
              <label for="otraFuente" class="form-label">¿Cuál?</label>
            <input
              type="text"
              class="form-control"
              id="otraFuente"
              autocomplete="off"
              maxlength="250"
              formControlName="otraFuente"
              placeholder="Especifica cómo te enteraste"
              appNextFieldId="idDepartamento"
              [ngClass]="{ 'is-invalid': validateField('otraFuente') }"
            />
              <div class="invalid-feedback">Campo obligatorio</div>
            </div>
          </div>
        }
      </div>

      <div class="row justify-content-center align-items-center mt-3 registro-nav-buttons">
        <div class="col-auto d-flex flex-wrap justify-content-center gap-3">
          <button type="button" class="btn-registro-nav btn-registro-nav--prev" (click)="goToPreviousStep()">
            <span class="btn-registro-nav__icon" aria-hidden="true">&lt;</span>
            <span class="btn-registro-nav__text">Anterior</span>
          </button>
          <button
            type="button"
            class="btn-registro-nav btn-registro-nav--next"
            [disabled]="!isStep1Valid()"
            (click)="goToNextStep()"
          >
            <span class="btn-registro-nav__text">Siguiente</span>
            <span class="btn-registro-nav__icon" aria-hidden="true">&gt;</span>
          </button>
        </div>
      </div>
    }

    @if (currentStep === 2) {
      <div class="form-section-header mb-3">
        <h3 class="form-section-header__title">Información financiera</h3>
        <p class="form-section-header__subtitle mt-3">
          <img src="assets/img/Inicio_sesion/svg/Ico_Info_Financiera.svg" 
          alt="" class="form-section-header__icon" aria-hidden="true" />
          Información financiera
        </p>
      </div>
      <div class="form-fields-flow mt-4">
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idDepartamento') }" required>
            <label for="idDepartamento" class="form-label">Departamento donde está tu negocio</label>
            <select
              class="form-control selectpicker"
              data-live-search="true"
              data-width="100%"
              data-size="5"
              #idDepartamento
              id="idDepartamento"
              title="Selecciona departamento"
              formControlName="idDepartamento"
              (change)="getCambio($event)"
              [ngClass]="{ 'is-invalid': validateField('idDepartamento') }"
              appNextFieldId="idCiudad"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona departamento</option>
              @for (departamento of departamentos; track departamento) {
                <option [value]="departamento.idDepartamento">
                  {{ departamento.nombreDepartamento }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo es obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idCiudad') }" required>
            <label for="idCiudad" class="form-label">Ciudad donde está tu negocio</label>
            <select
              #idCiudad
              id="idCiudad"
              class="form-control selectpicker"
              data-live-search="true"
              data-width="100%"
              data-size="5"
              formControlName="idCiudad"
              title="Selecciona ciudad"
              (change)="onCiudadChange()"
              [ngClass]="{ 'is-invalid': validateField('idCiudad') }"
              [appNextFieldId]="naturalForm.get('idCiudad').value == idBogota ? 'idLocalidad' : 'tiposContacto'"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona ciudad</option>
              @for (ciudad of ciudades; track ciudad) {
                <option [value]="ciudad.idCiudad">
                  {{ ciudad.nombreCiudad }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo es obligatorio</div>
          </div>
        </div>
        @if (naturalForm.get('idCiudad').value == idBogota) {
          <div class="form-field-item">
            <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('idLocalidad') }">
              <label for="idLocalidad" class="form-label">Localidad donde está ubicado tu negocio</label>
              <select
                #idLocalidad
                id="idLocalidad"
                class="form-control selectpicker"
                data-live-search="true"
                data-width="100%"
                data-size="5"
                formControlName="idLocalidad"
                title="Selecciona localidad"
                (change)="selectpikerChange('idLocalidad')"
                [ngClass]="{ 'is-invalid': validateField('idLocalidad') }"
                appNextFieldId="tiposContacto"
              >
                <option [value]="''" class="option-placeholder">Selecciona localidad</option>
                @for (loc of localidades; track loc) {
                  <option [value]="loc.id">
                    {{ loc.nombre }}
                  </option>
                }
              </select>
              <div class="invalid-feedback">Campo es obligatorio</div>
            </div>
          </div>
        }
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('tiposContacto') }">
            <label for="tiposContacto" class="form-label">¿Cómo deseas ser contactado?</label>
            <select
              #tiposContacto
              id="tiposContacto"
              class="form-control selectpicker"
              [ngClass]="{ 'is-invalid': validateField('tiposContacto') }"
              data-live-search="true"
              formControlName="tiposContacto"
              required
              data-size="4"
              multiple
              appNextFieldId="minoria"
              title="Selecciona una opción"
              data-actions-box="true"
              data-select-all-text="<i class='fas fa-plus'></i> Seleccionar todos"
              data-deselect-all-text="<i class='fas fa-minus'></i> Eliminar todos"
              (change)="selectpikerChangeContactos('tiposContacto')"
            >
              @for (tipo of listaTiposCont; track tipo) {
                <option [value]="tipo.idTipoContacto">
                  {{ tipo.nombre }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3" [ngClass]="{ 'is-invalid': validateField('minoria') }">
            <label for="minoria" class="form-label">¿Pertenece a alguna minoría?</label>
            <div>
              <div class="form-check form-check-inline ms-4" [ngClass]="{ 'is-invalid': validateField('minoria') }">
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="minoria"
                  [value]="1"
                  id="minoriaSi"
                  [ngClass]="{ 'is-invalid': validateField('minoria') }"
                  (click)="validarMinoria(1)"
                  (keydown.enter)="validarMinoria(1)"
                />
                <label for="minoriaSi" class="form-check-label">Sí</label>
              </div>
              <div class="form-check form-check-inline ms-4" [ngClass]="{ 'is-invalid': validateField('minoria') }">
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="minoria"
                  [value]="0"
                  id="minoriaNo"
                  [ngClass]="{ 'is-invalid': validateField('minoria') }"
                  (click)="validarMinoria(0)"
                  (keydown.enter)="validarMinoria(0)"
                />
                <label for="minoriaNo" class="form-check-label">No</label>
              </div>
              <div class="invalid-feedback">Campo obligatorio</div>
            </div>
          </div>
        </div>
        @if (naturalForm.get('minoria')?.value === 1) {
          <div class="form-field-item">
            <div class="mb-3" [ngClass]="{ 'is-invalid': validateField('minoriaDescripcion') }">
              <label for="minoriaDescripcion" class="form-label">¿Qué tipo de minoría?</label>
              <input
                type="text"
                class="form-control"
                formControlName="minoriaDescripcion"
                id="minoriaDescripcion"
                placeholder="Digita el tipo de minoría"
                [ngClass]="{ 'is-invalid': validateField('minoriaDescripcion') }"
              />
              <div class="invalid-feedback">Campo obligatorio</div>
            </div>
          </div>
        }
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('codigoCiiu') }">
            <label for="codigoCiiu" class="form-label">Actividad económica</label>
            <select
              #codigoCiiu
              id="codigoCiiu"
              class="form-control selectpicker"
              [ngClass]="{ 'is-invalid': validateField('codigoCiiu') }"
              data-live-search="true"
              formControlName="codigoCiiu"
              required
              data-size="6"
              appNextFieldId="anioVentas"
              (change)="selectpikerChange('codigoCiiu')"
              title="Selecciona actividad"
            >
              <option [value]="''" class="option-placeholder">Selecciona actividad</option>
              @for (ciiu of ciius; track ciiu) {
                <option [value]="ciiu.codigoCiiu" [attr.data-tokens]="ciiu.codigoCiiu">
                  {{ ciiu.codigoCiiu }} - {{ ciiu.nombreCiiu }}
                </option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('anioVentas') }">
            <label for="anioVentas" class="form-label">Año de ventas</label>
            <select
              class="form-control"
              formControlName="anioVentas"
              id="anioVentas"
              appNextFieldId="valorVentas"
              [ngClass]="{ 'is-invalid': validateField('anioVentas'), 'placeholder-selected': !naturalForm.get('anioVentas').value }"
              required
            >
              <option [value]="''" class="option-placeholder">Selecciona año de ventas</option>
              @for (anio of anios; track anio) {
                <option [value]="anio">{{ anio }}</option>
              }
            </select>
            <div class="invalid-feedback">Campo obligatorio</div>
          </div>
        </div>
        <div class="form-field-item">
          <div class="mb-3 required" [ngClass]="{ 'is-invalid': validateField('valorVentas') }" required>
            <label for="valorVentas" class="form-label">Ventas del último año</label>
            <input
              type="text"
              maxlength="17"
              class="form-control"
              formControlName="valorVentas"
              id="valorVentas"
              placeholder="Digita ventas"
              appOnlyNumbers
              appNextFieldId="tratamientoDatos"
              [ngClass]="{ 'is-invalid': validateField('valorVentas') }"
              required
              (keyup)="validarVentaAnual()"
            />
            <div class="invalid-feedback">{{ msjErrorValorVentas }}</div>
          </div>
        </div>
      </div>

      <div class="politicas mt-3">
        <div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="tratamientoDatos"
              [ngClass]="{ 'is-invalid': validateField('tratamientoDatos') }"
              formControlName="tratamientoDatos"
            />
            <label for="tratamientoDatos" class="form-check-label">
              Al seleccionar, aceptas nuestra
              <span
                (click)="showModal('P')"
                (keydown.enter)="showModal('P')"
                data-bs-target="#politicasModal"
                data-bs-toggle="modal"
                >política de tratamiento de datos personales.</span
              >
            </label>
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              [ngClass]="{ 'is-invalid': validateField('terminosCondiciones') }"
              formControlName="terminosCondiciones"
            />
            <label for="terminosCondiciones" class="form-check-label">
              Al seleccionar, aceptas nuestros
              <span
                (click)="showModal('T')"
                (keydown.enter)="showModal('T')"
                data-bs-target="#politicasModal"
                data-bs-toggle="modal"
                >términos y condiciones.</span
              >
            </label>
          </div>
        </div>
      </div>

      <div class="row justify-content-center align-items-center mt-3 mb-3 registro-nav-buttons">
        <div class="col-auto d-flex flex-wrap justify-content-center gap-3">
          <button type="button" class="btn-registro-nav btn-registro-nav--prev" (click)="goToPreviousStep()">
            <span class="btn-registro-nav__icon" aria-hidden="true">&lt;</span>
            <span class="btn-registro-nav__text">Anterior</span>
          </button>
          <button type="button" class="btn-registro-nav btn-registro-nav--next" disabled>
            <span class="btn-registro-nav__text">Siguiente</span>
            <span class="btn-registro-nav__icon" aria-hidden="true">&gt;</span>
          </button>
        </div>
      </div>
      <div class="row justify-content-center mt-4 mb-3">
        <div class="col-auto">
          <button class="btn-registro-nav btn-registro-nav--finish" type="submit" [disabled]="!isStep2Ready()" >
            <span class="btn-registro-nav__text">Finalizar registro</span>
            <img src="assets/img/Inicio_sesion/svg/Ico_Finalizar_registro.svg" alt="" class="btn-registro-nav__icon-img" aria-hidden="true" />
          </button>
        </div>
      </div>
    }
  </div>
</form>
<politicas-modal [title]="titleModal"></politicas-modal>
